export enum BasketballFourPointShotMissedAttribute {
  JumpShot = 859,
}
